/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon24Solid = forwardRef('ArrowShapeTriangleADownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.508 18.066 4.133 7.664C3.42 6.498 4.258 5 5.625 5h12.75c1.368 0 2.207 1.498 1.492 2.664l-6.375 10.402a1.75 1.75 0 0 1-2.984 0Z" })));
});
